import CardWithShell from './Card';
import CardContent from './components/CardContent';
import CardFooter from './components/CardFooter';
import CardHeader from './components/CardHeader';

const Card = Object.assign(CardWithShell, {
    Header: CardHeader,
    Content: CardContent,
    Footer: CardFooter
});

export default Card;
